import React, { useEffect } from 'react';
import { MsalProvider } from '@azure/msal-react';
import AppContext from './context/AppContext';
import routes from './routes';
import AuthVerification from './components/AuthVerification';
import UWEContext from './context/UWEContext';
import { UWEThemeProvider } from './context/UWEThemeContext';
import RouteSwitch from './components/RouteSwitch';
import initAppConfiguration from './hooks/initAppConfiguration';
import { msalInstance } from './msalConfig';
import { AD_CLIENT_ID, APP_NAME, BACKEND } from './constants';
import ModalContext from './context/ModalContext';
import { OpenCasesProvider } from './context/OpenCasesContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorFallback from './components/ErrorFallback';
import ChatApp from "./views/ChatApp";
import { USE_AI } from "./constants";

const ConfigurationProvider = initAppConfiguration({
  LOGO_SRC: `${BACKEND}/template-files/logo.png`, // "uwe_logo.svg",
  APP_NAME,
  AD_CLIENT_ID,
});

function App() {
  let app = (
    <ErrorBoundary fallback={ErrorFallback}>
      <ConfigurationProvider>
        <AuthProvider>
          <AppContexts>
            <UWEContext.Component>
              <OpenCasesProvider>
                <AuthVerification />
                {USE_AI && <ChatApp />}
                <RouteSwitch routes={routes} />
              </OpenCasesProvider>
            </UWEContext.Component>
          </AppContexts>
        </AuthProvider>
      </ConfigurationProvider>
    </ErrorBoundary>
  );

  if (msalInstance) {
    app = <MsalProvider instance={msalInstance}>{app}</MsalProvider>;
  }

  app = <UWEThemeProvider>{app}</UWEThemeProvider>;

  return app;
}

function AppContexts({ children, auth }) {
  let element = children;
  element = <ModalContext.ProviderComponent>{element}</ModalContext.ProviderComponent>;
  element = <AppContext.Component>{element}</AppContext.Component>;

  return element;
}

export default App;
